import { getRegionId } from '../../utils/geo';

import type { IAppState } from '../../common/state';

export const selectRegionId = (state: IAppState): number => {
  return getRegionId(state.currentLocation);
};
